// extracted by mini-css-extract-plugin
module.exports = {"context-menu-list":"context-menu-list_context-menu-list__2CjiX"};